import { createPortal } from "react-dom";
import type { TutorialDemoOverlay, TutorialStep } from "../../Constants/tutorialSteps";
import { TutorialDemoCompleteInsightModal } from "./TutorialDemoCompleteInsightModal";
import { TutorialDemoDismissInsightModal } from "./TutorialDemoDismissInsightModal";
import { TutorialDemoSocialPromptModal } from "./TutorialDemoSocialPromptModal";
import "../../Css/Tutorial/TutorialDemoOverlay.css";

type TutorialDemoOverlaysProps = {
  step: TutorialStep | null;
};

function isSocialDemoOverlay(
  overlay: TutorialDemoOverlay | undefined,
): overlay is "social-prompt" | "social-prompt-request" {
  return overlay === "social-prompt" || overlay === "social-prompt-request";
}

export function TutorialDemoOverlays({ step }: TutorialDemoOverlaysProps) {
  if (!step?.demoOverlay) return null;

  const showSocial = isSocialDemoOverlay(step.demoOverlay);
  const showComplete = step.demoOverlay === "complete-insight";
  const showDismiss = step.demoOverlay === "dismiss-insight";

  if (!showSocial && !showComplete && !showDismiss) return null;

  return createPortal(
    <div className="tutorialDemoOverlay_root" aria-hidden={false}>
      {showSocial ? (
        <TutorialDemoSocialPromptModal
          view={step.demoOverlay === "social-prompt-request" ? "request" : "compose"}
        />
      ) : null}
      {showComplete ? <TutorialDemoCompleteInsightModal /> : null}
      {showDismiss ? <TutorialDemoDismissInsightModal /> : null}
    </div>,
    document.body,
  );
}
